import React, {useState} from 'react';
import {useFormContext} from 'react-hook-form';
import {useSelector} from 'react-redux';
import ProjectService from 'src/modules/project/projectService';
import selectors from 'src/modules/project/projectSelectors';
import AutocompleteInMemoryFormItem from 'src/view/shared/form/items/AutocompleteInMemoryFormItem';
import ProjectFormModal from 'src/view/project/form/ProjectFormModal';

function projectDisplayLabel(value) {
  if (!value) return '';
  if (value.label) return value.label;
  const name = String(value.name || '').trim();
  const code = String(value.code || '').trim();
  return code ? `${code} — ${name}` : name;
}

function ProjectAutocompleteFormItem(props) {
  const {setValue, getValues} = useFormContext();

  const [modalVisible, setModalVisible] = useState(false);

  const hasPermissionToCreate = useSelector(selectors.selectPermissionToCreate);

  const doCloseModal = () => {
    setModalVisible(false);
  };

  const doOpenModal = () => {
    setModalVisible(true);
  };

  const doCreateSuccess = (record) => {
    const {name, mode} = props;
    const mapped = {
      id: record.id,
      label: projectDisplayLabel(record),
      name: record.name,
      code: record.code,
    };

    if (mode && mode === 'multiple') {
      setValue(name, [...(getValues()[name] || []), mapped], {shouldValidate: true, shouldDirty: true});
    } else {
      setValue(name, mapped, {shouldValidate: true, shouldDirty: true});
    }

    doCloseModal();
  };

  const fetchFn = (value, limit) => {
    if (props.filter) {
      return ProjectService.listAutocomplete({value, filter: props.filter}, limit);
    }
    return ProjectService.listAutocomplete(value, limit);
  };

  const mapper = {
    toAutocomplete(originalValue) {
      if (!originalValue) {
        return null;
      }

      return {
        key: originalValue.id,
        value: originalValue.id,
        label: projectDisplayLabel(originalValue),
        name: originalValue.name,
        code: originalValue.code,
      };
    },

    toValue(originalValue) {
      if (!originalValue) {
        return null;
      }

      return {
        id: originalValue.value,
        label: originalValue.label,
        name: originalValue.name,
        code: originalValue.code,
      };
    },
  };

  return (
    <>
      <AutocompleteInMemoryFormItem
        {...props}
        fetchFn={fetchFn}
        entity="project"
        mapper={mapper}
        onOpenModal={props.showCreate === false ? undefined : doOpenModal}
        hasPermissionToCreate={props.showCreate === false ? false : hasPermissionToCreate}
      />

      {modalVisible && <ProjectFormModal onClose={doCloseModal} onSuccess={doCreateSuccess} />}
    </>
  );
}

export default ProjectAutocompleteFormItem;
